import { useContext, useState, useEffect } from "react";
import { connect } from "react-redux";
import "./createClassLink.css";
import axios from "../../../axios";
import "./createClassLink.css";
import { SubStdSelContext } from "../../../SubStdSelContext";
import CreatedSuccessfull from "./CreatedSuccessfully";
import { IP } from "../../../internalServer";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  TextField,
  Select,
  MenuItem,
  Switch,
  FormControlLabel,
  Divider,
  Checkbox,
  Chip,
  FormControl,
} from "@mui/material";

export let _id;

const mapStateToProps = (props) => {
  return {
    inc: props.redres,
    dec: props.redres1,
  };
};

// ---- SAFE date helpers with null checks ----
const dateTransform = (par) => {
  try {
    if (!par) return "";
    let salute;
    let dateString = par.toString();
    let dateInfo = dateString.split(" ");
    if (!dateInfo[4]) return "";
    let timeInfo = dateInfo[4].split(":");
    if (!timeInfo[0] || !timeInfo[1]) return "";

    let hours = parseInt(timeInfo[0]);

    if (hours < 12 || hours === 24) {
      salute = "AM";
      if (hours === 0 || hours === 24) {
        hours = 12;
      }
    } else {
      salute = "PM";
      if (hours > 12) {
        hours -= 12;
      }
    }

    let formattedHours = hours < 10 ? "0" + hours : hours;
    let minutes = timeInfo[1];
    let res = formattedHours + ":" + minutes + " " + salute;
    return res;
  } catch (error) {
    console.log("dateTransform error:", error);
    return "";
  }
};

const dateTransformLive = (parameter1) => {
  try {
    if (!parameter1) return "";
    let dateString = parameter1.toString();
    let date = new Date(dateString);
    if (isNaN(date.getTime())) return "";

    let year = date.getFullYear();
    let month = ("0" + (date.getMonth() + 1)).slice(-2);
    let day = ("0" + date.getDate()).slice(-2);
    let formattedDate = year + "-" + month + "-" + day;
    return formattedDate;
  } catch (error) {
    console.log("dateTransformLive error:", error);
    return "";
  }
};

const dayTransform = (parameter) => {
  try {
    if (!parameter) return "";
    let dateString = parameter.toString();
    let dayInfo = dateString.split(" ");
    if (!dayInfo[0]) return "";

    let timeInfo = dayInfo[0];
    switch (timeInfo) {
      case "Mon":
        timeInfo = "Monday";
        break;
      case "Tue":
        timeInfo = "Tuesday";
        break;
      case "Wed":
        timeInfo = "Wednesday";
        break;
      case "Thu":
        timeInfo = "Thursday";
        break;
      case "Fri":
        timeInfo = "Friday";
        break;
      case "Sat":
        timeInfo = "Saturday";
        break;
      case "Sun":
        timeInfo = "Sunday";
        break;
      default:
        timeInfo = timeInfo;
    }
    return timeInfo;
  } catch (error) {
    console.log("dayTransform error:", error);
    return "";
  }
};

const CreateClassLink = ({
  event,
  inc,
  dec,
  setClick1,
  refetch2,
  SDate,
  EDate,
  click1,
  bookChapterList,
  editData,
  isEdit,
}) => {
  const {
    secSelectedOption,
    stdSelectedOption,
    teacherDCM,
    secSelectedOptionName,
    stdSelectedOptionName,
  } = useContext(SubStdSelContext);

  const [sucess, setSucess] = useState(false);
  const [createclassvariable, setCreateClassVariable] = useState({
    subjectName: "",
    description: "",
    joinmute: true,
    moderatorapproval: true,
    any_to_start_session: false,
    allasModerator: false,
    autojoin: false,
    modunmuteUser: false,
    disableprivatechat: true,
    audioCheck: true,
    listenMode: true,
    accessCode: false,
    welcomeMsg: "",
  });

  const [chapterId, setChapterId] = useState("");
  const [bookId, setBookId] = useState("");
  const [isToggled, setIsToggled] = useState({
    joinMute: true,
    moderatorApproval: true,
    anyToStartSession: false,
    allAsModerator: false,
    autoJoin: false,
    modUnmuteUser: false,
    disablePrivateChat: true,
    AudioCheck: true,
    ListenMode: true,
    AccessCode: false,
  });

  // ---- Student Selection States ----
  const [studentsList, setStudentsList] = useState([]);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [allowedStudentsMode, setAllowedStudentsMode] = useState("ALL");

  const schoolId = JSON.parse(localStorage.getItem("schoolId"));

  // ---- Effect 1: Initialize form when editData changes ----
  useEffect(() => {
    if (isEdit && editData) {
      setCreateClassVariable({
        subjectName: editData?.name || "",
        description: editData?.description || "",
        joinmute: editData?.mute_on_start ?? true,
        moderatorapproval: editData?.require_moderator_approval ?? true,
        any_to_start_session: editData?.any_to_start_session ?? false,
        allasModerator: editData?.join_as_moderator ?? false,
        autojoin: editData?.auto_join ?? false,
        modunmuteUser: editData?.allow_mods_to_unmute_users ?? false,
        disableprivatechat:
          editData?.lock_settings_disable_private_chat ?? true,
        audioCheck: editData?.audioCheck ?? true,
        listenMode: editData?.listenMode ?? true,
        accessCode: false,
        welcomeMsg: editData?.welcome_message || "",
      });

      setIsToggled({
        joinMute: editData?.mute_on_start ?? true,
        moderatorApproval: editData?.require_moderator_approval ?? true,
        anyToStartSession: editData?.any_to_start_session ?? false,
        allAsModerator: editData?.join_as_moderator ?? false,
        autoJoin: editData?.auto_join ?? false,
        modUnmuteUser: editData?.allow_mods_to_unmute_users ?? false,
        disablePrivateChat:
          editData?.lock_settings_disable_private_chat ?? true,
        AudioCheck: editData?.audioCheck ?? true,
        ListenMode: editData?.listenMode ?? true,
        AccessCode: false,
      });

      const mode = editData?.allowedStudentsMode || "ALL";
      setAllowedStudentsMode(mode);
      if (mode === "SELECTED" && editData?.allowedStudents?.length > 0) {
        setSelectedStudents(editData.allowedStudents);
      } else {
        setSelectedStudents([]);
      }
    }
  }, [isEdit, editData]);

  // ---- Effect 2: Fetch students list ----
  useEffect(() => {
    const fetchStudents = async () => {
      try {
        const res = await axios.get(
          `/api/v1/school/student/get/school/${schoolId}`,
        );
        if (res.data?.status === true) {
          const list = res?.data?.data || [];
          const filteredListByStdSec = list.filter(
            (student) =>
              student?.standard?.id === stdSelectedOption &&
              student?.section?.id === secSelectedOption,
          );
          setStudentsList(filteredListByStdSec);

          if (!isEdit) {
            setSelectedStudents([]);
            setAllowedStudentsMode("ALL");
          }
        }
      } catch (error) {
        console.log("Error fetching students:", error);
      }
    };

    if (stdSelectedOption && secSelectedOption) {
      fetchStudents();
    }
  }, [stdSelectedOption, secSelectedOption, schoolId, isEdit]);

  const handleAccessCode = () => {
    if (isEdit) return; // Read-only in edit mode
    setCreateClassVariable({
      ...createclassvariable,
      accessCode: !createclassvariable.accessCode,
    });
  };
  const handleAudioCheck = () => {
    if (isEdit) return;
    setCreateClassVariable({
      ...createclassvariable,
      audioCheck: !createclassvariable.audioCheck,
    });
  };
  const handleListenMode = () => {
    if (isEdit) return;
    setCreateClassVariable({
      ...createclassvariable,
      ListenMode: !createclassvariable.ListenMode,
    });
  };
  const handleJoinMute = () => {
    if (isEdit) return;
    setCreateClassVariable({
      ...createclassvariable,
      joinmute: !createclassvariable.joinmute,
    });
  };
  const handleModeratorApproval = () => {
    if (isEdit) return;
    setCreateClassVariable({
      ...createclassvariable,
      moderatorapproval: !createclassvariable.moderatorapproval,
    });
  };
  const anyToStartSession = () => {
    if (isEdit) return;
    setCreateClassVariable({
      ...createclassvariable,
      any_to_start_session: !createclassvariable.any_to_start_session,
    });
  };
  const allAsModerator = () => {
    if (isEdit) return;
    setCreateClassVariable({
      ...createclassvariable,
      allasModerator: !createclassvariable.allasModerator,
    });
  };
  const autoJoin = () => {
    if (isEdit) return;
    setCreateClassVariable({
      ...createclassvariable,
      autojoin: !createclassvariable.autojoin,
    });
  };
  const modUnmuteUser = () => {
    if (isEdit) return;
    setCreateClassVariable({
      ...createclassvariable,
      modunmuteUser: !createclassvariable.modunmuteUser,
    });
  };
  const disablePrivateChat = () => {
    if (isEdit) return;
    setCreateClassVariable({
      ...createclassvariable,
      disableprivatechat: !createclassvariable.disableprivatechat,
    });
  };

  const handleStudentModeToggle = () => {
    const newMode = allowedStudentsMode === "ALL" ? "SELECTED" : "ALL";
    setAllowedStudentsMode(newMode);
    if (newMode === "SELECTED") {
      if (selectedStudents.length === 0) {
        setSelectedStudents(studentsList.map((s) => s.id));
      }
    } else {
      setSelectedStudents([]);
    }
  };

  const handleCreateClass = async () => {
    const safeEvent = event || {};

    if (isEdit && event?.id) {
      // ---- EDIT MODE: Two separate API calls ----
      try {
        // 1. Update basic details (name, description, welcome_message)
        const updateClassPayload = {
          bbbClass_id: event?.id,
          name: createclassvariable.subjectName,
          description: createclassvariable.description,
          welcome_message: createclassvariable.welcomeMsg,
        };

        await axios.put(
          "/api/v1/videoConference/classes/updateClass",
          updateClassPayload,
        );

        // 2. Update student access control
        const updateAccessPayload = {
          bbbClass_id: event.id,
          allowedStudentsMode: allowedStudentsMode,
          allowedStudents:
            allowedStudentsMode === "SELECTED" ? selectedStudents : [],
        };

        await axios.put(
          "/api/v1/videoConference/classes/updateAccessControl",
          updateAccessPayload,
        );

        setSucess(true);
      } catch (error) {
        console.log("Edit error:", error);
      }
      return;
    }

    // ---- CREATE MODE: Original flow ----
    let Teacher_Id = JSON.parse(localStorage.getItem("Teacher_id"));

    let newRes = {
      standard_id: stdSelectedOption,
      teacher_id: Teacher_Id,
      subject_id: safeEvent.Subject_id,
      section_id: secSelectedOption,
      name: createclassvariable.subjectName,
      description: createclassvariable.description,
      any_to_start_session: createclassvariable.any_to_start_session,
      join_as_moderator: createclassvariable.allasModerator,
      logo: `${IP}public/upload/logo/Logo.png`,
      record: true,
      mute_on_start: createclassvariable.joinmute,
      welcome_message: createclassvariable?.welcomeMsg,
      allow_mods_to_unmute_users: createclassvariable.modunmuteUser,
      wallpaper:
        "https://cdn.pixabay.com/photo/2016/02/06/09/56/science-1182713_1280.jpg",
      dark_color: "##ffff",
      logout_url:
        "https://cdn.pixabay.com/photo/2016/02/06/09/56/science-1182713_1280.jpg",
      light_color: "#7BDEFF",
      primary_color: "blue",
      meeting_layout: "SMART_LAYOUT",
      lock_settings_disable_private_chat:
        createclassvariable.disableprivatechat,
      require_moderator_approval: createclassvariable.moderatorapproval,
      auto_join: createclassvariable.autojoin,
      webcams_only_for_moderator: true,
      lockSettingsHideUserList: true,
      audioCheck: createclassvariable.audioCheck,
      listenMode: createclassvariable.listenMode,
      banner_color: "#00000",
      banner_text: "Breathe4School",
      duration: 0,
      add_to_live_session: {
        lecture_id: safeEvent.Id,
        date: dateTransformLive(safeEvent?.StartTime),
      },
    };

    if (chapterId && chapterId.trim() !== "") {
      newRes.chapter_id = chapterId;
    }

    if (bookId && bookId.trim() !== "") {
      newRes.book_id = bookId;
    }

    if (allowedStudentsMode === "SELECTED" && selectedStudents.length > 0) {
      newRes.allowedStudentsMode = "SELECTED";
      newRes.allowedStudents = selectedStudents;
    } else {
      newRes.allowedStudentsMode = "ALL";
      newRes.allowedStudents = [];
    }

    try {
      await axios
        .post("/api/v1/videoConference/classes/createNotLink", newRes)
        .then((res) => {
          if (res.data.status === true) {
            _id = res.data.data?.id;
            setSucess(true);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const clickOk = () => {
    setClick1(false);
    if (!isEdit) {
      refetch2(stdSelectedOption, secSelectedOption, SDate, EDate);
    }
  };

  const [chapter1, setChapter1] = useState([]);
  const findChapterById = (array, id) => {
    const book = array.find((book) => book.id === id);
    if (book) {
      const firstChapter = book.chapterData;
      setChapter1(firstChapter);
    } else {
      console.error(`No book found with id: ${id}`);
    }
  };

  const isCreateDisabled =
    !createclassvariable.subjectName.trim() ||
    !createclassvariable.description.trim();

  console.log("eventDAta", event);
  return (
    <>
      <Dialog
        open
        onClose={() => setClick1(false)}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: { borderRadius: "16px", overflow: "hidden" },
        }}
      >
        <DialogTitle
          sx={{
            bgcolor: "#FF6B00",
            color: "white",
            textAlign: "center",
            fontWeight: 600,
            py: 2,
          }}
        >
          {isEdit ? "Update Online Session" : "Create Online Session"}
        </DialogTitle>

        <DialogContent
          dividers
          sx={{ p: { xs: 2, md: 3 } }}
          className="orange-scrollBar poppins-semibold"
        >
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              justifyContent: "center",
              gap: 2,
              p: 2,
              mb: 3,
              borderRadius: 2,
              bgcolor: "#F9FAFB",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              textAlign: "center",
            }}
          >
            <Typography
              variant="body1"
              sx={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                justifyContent: "center",
                gap: 1.5,
                fontWeight: 500,
                color: "text.primary",
                "& span": {
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                },
              }}
            >
              <span>
                📘 {stdSelectedOptionName}-{secSelectedOptionName}
              </span>
              {!isEdit && (
                <>
                  <span>📅 {dayTransform(event?.StartTime)}</span>
                  <span>
                    ⏰ {dateTransform(event?.StartTime)} -{" "}
                    {dateTransform(event?.EndTime)}
                  </span>
                  <span>📖 {event?.Subject}</span>
                  <span>👨‍🏫 {event?.TeacherName}</span>
                </>
              )}
            </Typography>
          </Box>

          {/* Class Name - EDITABLE in both modes */}
          <Box className="row mb-3">
            <div className="col-md-6">
              <Typography variant="body2" fontWeight={600}>
                Class Name<span style={{ color: "red" }}>*</span>
              </Typography>
              <TextField
                fullWidth
                placeholder="Enter Class Name"
                value={createclassvariable.subjectName}
                onChange={(event) =>
                  setCreateClassVariable({
                    ...createclassvariable,
                    subjectName: event.target.value,
                  })
                }
                sx={{ mt: 1 }}
              />
            </div>

            {/* Access Code - HIDDEN in edit mode */}
            {!isEdit && (
              <div className="col-md-6">
                <Typography variant="body2" fontWeight={600}>
                  Access Code
                </Typography>

                <Box
                  className="d-flex align-items-center gap-2 mt-1"
                  style={{ width: "100%" }}
                >
                  <TextField
                    fullWidth
                    placeholder="Optional Access Code"
                    disabled={!createclassvariable.accessCode}
                    onChange={(e) => {}}
                    sx={{ flex: 1 }}
                  />

                  <Switch
                    checked={createclassvariable.accessCode}
                    onClick={handleAccessCode}
                    sx={{
                      "& .MuiSwitch-switchBase.Mui-checked": {
                        color: "#FF6B00",
                      },
                      "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                        {
                          backgroundColor: "#FF6B00",
                        },
                    }}
                  />
                </Box>
              </div>
            )}
          </Box>

          {/* Description - EDITABLE in both modes */}
          <Box className="mb-3">
            <Typography variant="body2" fontWeight={600}>
              Description<span style={{ color: "red" }}>*</span>
            </Typography>
            <TextField
              fullWidth
              multiline
              rows={2}
              maxLength={250}
              placeholder="Enter session description"
              value={createclassvariable.description}
              onChange={(event) =>
                setCreateClassVariable({
                  ...createclassvariable,
                  description: event.target.value,
                })
              }
              sx={{ mt: 1 }}
            />
          </Box>

          {/* Book and Chapter - HIDDEN in edit mode */}
          {!isEdit && (
            <Box className="row mb-3">
              <div className="col-md-6">
                <Typography variant="body2" fontWeight={600}>
                  Book
                </Typography>
                <Select
                  fullWidth
                  displayEmpty
                  value={bookId}
                  onChange={(e) => {
                    const selectedBookId = e.target.value;
                    setBookId(selectedBookId);
                    setChapter1([]);
                    findChapterById(bookChapterList, selectedBookId);
                  }}
                  sx={{ mt: 1 }}
                >
                  <MenuItem value="">Select Book</MenuItem>
                  {bookChapterList.map((book) => (
                    <MenuItem key={book.id} value={book.id}>
                      {book.name}
                    </MenuItem>
                  ))}
                </Select>
              </div>

              <div className="col-md-6">
                <Typography variant="body2" fontWeight={600}>
                  Chapter
                </Typography>
                <Select
                  fullWidth
                  displayEmpty
                  value={chapterId}
                  onChange={(e) => setChapterId(e.target.value)}
                  sx={{ mt: 1 }}
                  disabled={!bookId}
                >
                  {console.log(chapter1, "chapter1")}
                  <MenuItem value="">Select Chapter</MenuItem>
                  {chapter1.length > 0 ? (
                    chapter1.map((ch) => (
                      <MenuItem key={ch.id} value={ch.id}>
                        {ch.chapterName}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>No chapters available</MenuItem>
                  )}
                </Select>
              </div>
            </Box>
          )}

          {/* Welcome Message - EDITABLE in both modes */}
          <Box className="mb-4">
            <Typography variant="body2" fontWeight={600}>
              Welcome Message
            </Typography>
            <TextField
              fullWidth
              maxLength={50}
              placeholder="Enter welcome message"
              value={createclassvariable.welcomeMsg}
              onChange={(event) =>
                setCreateClassVariable({
                  ...createclassvariable,
                  welcomeMsg: event.target.value,
                })
              }
              sx={{ mt: 1 }}
            />
          </Box>

          {/* ---- Student Selection Section - EDITABLE in both modes ---- */}
          <Box className="mb-4">
            <Typography variant="body2" fontWeight={600}>
              Student Access
            </Typography>

            <Box
              sx={{
                mt: 1,
                display: "flex",
                alignItems: "center",
                gap: 2,
                mb: 2,
              }}
            >
              <Typography variant="body2" fontWeight={500}>
                All Students
              </Typography>
              <Switch
                checked={allowedStudentsMode === "SELECTED"}
                onClick={handleStudentModeToggle}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": { color: "#FF6B00" },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#FF6B00",
                  },
                  "&.Mui-disabled": {
                    opacity: 0.5,
                  },
                }}
              />
              <Typography variant="body2" fontWeight={500}>
                Selected Students Only
              </Typography>
            </Box>

            {allowedStudentsMode === "SELECTED" && (
              <Box sx={{ mt: 1 }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 1,
                    mb: 1,
                  }}
                >
                  <Button
                    size="small"
                    onClick={() =>
                      setSelectedStudents(studentsList.map((s) => s.id))
                    }
                    sx={{
                      color: "#FF6B00",
                      borderColor: "#FF6B00",
                      fontSize: "12px",
                      textTransform: "none",
                      "&.Mui-disabled": {
                        borderColor: "#ccc",
                        color: "#ccc",
                      },
                    }}
                    variant="outlined"
                  >
                    Select All
                  </Button>
                  <Button
                    size="small"
                    onClick={() => setSelectedStudents([])}
                    sx={{
                      color: "#FF6B00",
                      borderColor: "#FF6B00",
                      fontSize: "12px",
                      textTransform: "none",
                      "&.Mui-disabled": {
                        borderColor: "#ccc",
                        color: "#ccc",
                      },
                    }}
                    variant="outlined"
                  >
                    Unselect All
                  </Button>
                </Box>

                <FormControl fullWidth>
                  <Select
                    multiple
                    displayEmpty
                    value={selectedStudents}
                    onChange={(e) => {
                      setSelectedStudents(e.target.value);
                    }}
                    renderValue={(selected) => (
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                        {selected.length === 0 ? (
                          <Typography variant="body2" color="text.secondary">
                            No students selected
                          </Typography>
                        ) : (
                          selected.map((value) => {
                            const student = studentsList.find(
                              (s) => s.id === value,
                            );
                            return (
                              <Chip
                                key={value}
                                label={student?.name || value}
                                size="small"
                                sx={{
                                  bgcolor: "#FFF3E0",
                                  color: "#FF6B00",
                                  borderRadius: "8px",
                                  fontWeight: 500,
                                }}
                              />
                            );
                          })
                        )}
                      </Box>
                    )}
                    sx={{
                      mt: 1,
                      "&.Mui-disabled": {
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                  >
                    {studentsList.length === 0 && (
                      <MenuItem disabled>No students found</MenuItem>
                    )}
                    {studentsList.map((student) => (
                      <MenuItem key={student.id} value={student.id}>
                        <Checkbox
                          checked={selectedStudents.indexOf(student.id) > -1}
                          sx={{
                            color: "#FF6B00",
                            "&.Mui-checked": { color: "#FF6B00" },
                          }}
                        />
                        <Typography variant="body2">
                          {student.name} (
                          {student.admissionNumber || student.code || "N/A"})
                        </Typography>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            )}
          </Box>

          {/* ---- Session Settings - READ ONLY in edit mode ---- */}

          {/* <Typography variant="h6" sx={{ color: "#FF6B00", mb: 2 }}>
            Session Settings
            {isEdit && (
              <Typography
                component="span"
                variant="caption"
                sx={{ ml: 1, color: "text.secondary", fontStyle: "italic" }}
              >
                (Read Only)
              </Typography>
            )}
          </Typography> */}

          {/* {[
            {
              label: "Mute users when they join",
              state: "joinMute",
              handler: handleJoinMute,
            },
            {
              label: "Require moderator approval before joining",
              state: "moderatorApproval",
              handler: handleModeratorApproval,
            },
            {
              label: "Enable any user to start this session",
              state: "anyToStartSession",
              handler: anyToStartSession,
            },
            {
              label: "All users join as moderators",
              state: "allAsModerator",
              handler: allAsModerator,
            },
            {
              label: "Automatically join me into the class",
              state: "autoJoin",
              handler: autoJoin,
            },
          ].map((item, i) => (
            <Box
              key={i}
              className="d-flex justify-content-between align-items-center mb-2"
            >
              <Typography sx={{ opacity: isEdit ? 0.6 : 1 }}>
                {item.label}
              </Typography>
              <Switch
                checked={isToggled[item.state]}
                onClick={() => {
                  if (!isEdit) {
                    setIsToggled({
                      ...isToggled,
                      [item.state]: !isToggled[item.state],
                    });
                    item.handler();
                  }
                }}
                disabled={isEdit}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": { color: "#FF6B00" },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#FF6B00",
                  },
                  "&.Mui-disabled": {
                    opacity: 0.4,
                  },
                }}
              />
            </Box>
          ))} */}

          {/* ---- Advanced Settings - READ ONLY in edit mode ---- */}
          {/* <Typography variant="h6" sx={{ color: "#FF6B00", mb: 2 }}>
            Advanced Settings
            {isEdit && (
              <Typography
                component="span"
                variant="caption"
                sx={{ ml: 1, color: "text.secondary", fontStyle: "italic" }}
              >
                (Read Only)
              </Typography>
            )}
          </Typography> */}

          {/* {[
            {
              label: "Enable moderator to unmute users",
              state: "modUnmuteUser",
              handler: modUnmuteUser,
            },
            {
              label: "Skip audio check",
              state: "AudioCheck",
              handler: handleAudioCheck,
            },
            {
              label: "Disable listen only mode",
              state: "ListenMode",
              handler: handleListenMode,
            },
            {
              label: "Enable user's private chats",
              state: "disablePrivateChat",
              handler: disablePrivateChat,
            },
          ].map((item, i) => (
            <Box
              key={i}
              className="d-flex justify-content-between align-items-center mb-2"
            >
              <Typography sx={{ opacity: isEdit ? 0.6 : 1 }}>
                {item.label}
              </Typography>
              <Switch
                checked={isToggled[item.state]}
                onClick={() => {
                  if (!isEdit) {
                    setIsToggled({
                      ...isToggled,
                      [item.state]: !isToggled[item.state],
                    });
                    item.handler();
                  }
                }}
                disabled={isEdit}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": { color: "#FF6B00" },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#FF6B00",
                  },
                  "&.Mui-disabled": {
                    opacity: 0.4,
                  },
                }}
              />
            </Box>
          ))} */}

          {/* Class Layout - READ ONLY in edit mode */}
          {/* <Box className="mt-3">
            <Typography variant="body2" fontWeight={600}>
              Update Class Layout
              {isEdit && (
                <Typography
                  component="span"
                  variant="caption"
                  sx={{ ml: 1, color: "text.secondary", fontStyle: "italic" }}
                >
                  (Read Only)
                </Typography>
              )}
            </Typography>
            <Select
              fullWidth
              sx={{ mt: 1 }}
              disabled={isEdit}
              value="0" // Default value for edit mode display
            >
              <MenuItem value="0">SMART LAYOUT</MenuItem>
              <MenuItem value="1">VIDEO FOCUS</MenuItem>
              <MenuItem value="2">PRESENTATION FOCUS</MenuItem>
              <MenuItem value="3">CUSTOM LAYOUT</MenuItem>
            </Select>
          </Box> */}
        </DialogContent>

        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button
            onClick={() => setClick1(false)}
            variant="outlined"
            sx={{
              borderColor: "#FF6B00",
              color: "#FF6B00",
              "&:hover": { bgcolor: "#FF6B00", color: "white" },
              borderRadius: "10px",
            }}
          >
            Discard
          </Button>
          <Button
            onClick={handleCreateClass}
            variant="contained"
            disabled={isCreateDisabled}
            sx={{
              bgcolor: isCreateDisabled ? "#ffbb80" : "#FF6B00",
              color: "white",
              "&:hover": {
                bgcolor: isCreateDisabled ? "#ffbb80" : "#e56a00",
              },
              borderRadius: "10px",
              cursor: isCreateDisabled ? "not-allowed" : "pointer",
            }}
          >
            {isEdit ? "Update Class" : "Create Class"}
          </Button>
        </DialogActions>
      </Dialog>

      {sucess && <CreatedSuccessfull onSucess={clickOk} />}
    </>
  );
};
export default connect(mapStateToProps)(CreateClassLink);
